import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import SnackbarComponent from "../../components/Snackbar/Snackbar";
import axios from "axios";
import { backendUrl } from "../../constants/config";

const Login = () => {
  const navigate = useNavigate();
  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleLoginSuccess = async (response) => {
    const decoded = jwtDecode(response.credential);
    const { name, email } = decoded;

    try {
      const resp = await axios.post(`${backendUrl}/user/loginUser`, { name, email });
      localStorage.setItem("TalentSyncUser", JSON.stringify(resp.data.user));
      setSuccess("Successfully logged in!");

      if (resp.data.user.userType === "admin") {
        navigate("/admin-dashboard/home");
      } else if (resp.data.user.subscriptionBought) {
        navigate("/dashboard/gmailtrucker");
      } else {
        navigate("/apply");
      }
    } catch {
      setErr("Error Logging in.");
    }
  };

  return (
    <div style={styles.page}>
      <SnackbarComponent err={err} success={success} setErr={setErr} setSuccess={setSuccess} />
      <div style={styles.card}>
        <h2 style={styles.title}>Sign in with Google</h2>
        <p style={styles.subtitle}>Access your online account securely</p>
        <GoogleLogin
          onSuccess={handleLoginSuccess}
          onError={() => setErr("Google login failed")}
        />
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
  },
  card: {
    width: "100%",
    maxWidth: "400px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "2rem",
    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "1rem",
    color: "#333",
  },
  subtitle: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "2rem",
  },
};

export default Login;
